import {ModelSetOptions} from 'backbone';

import * as navigation from 'Navigation';

interface AntibodyMapTabStateAttributes {
  antibodyId: string;
  isEditable: boolean;
}

interface AntibodyMapTabState {
  get<K extends keyof AntibodyMapTabStateAttributes>(key: K): AntibodyMapTabStateAttributes[K];
  set<K extends keyof AntibodyMapTabStateAttributes>(
    attributeName: K,
    value: AntibodyMapTabStateAttributes[K],
    options?: ModelSetOptions
  ): AntibodyMapTabState;
  set(obj: Partial<AntibodyMapTabStateAttributes>): AntibodyMapTabStateAttributes;
}

class AntibodyMapTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Antibody Map',
      closeable: false,
      preferenceKey: 'antibody-map',
    };
  }
}

export default AntibodyMapTabState;
